import { b as t } from "./withEditable-7d0a220a.js";
import { R as i, i as o } from "./RichTextEditor-74d706e9.js";
import "react/jsx-runtime";
import "@adobe/aem-react-editable-components";
import "@adobe/aem-spa-page-model-manager";
import "react";
import "./PageContext-57b2437f.js";
import "./component-a7888ba1.js";
import "./EditableComponentUtils-0b5699b7.js";
import "html-react-parser";
import "sanitize-html";
import "@ucl/react-library/useIsMounted";
import "./ComponentContext-3bb2d205.js";
import "./withErrorBoundary.js";
import "@ucl/shared-component-foundations/foundations";
import "styled-components";
import "./index-0371017d.js";
import "./parseHTMLString-24a59cc8.js";
import "./sanitizeHtml-95395ce0.js";
import "./sanitizeProps-304c699d.js";
const r = "ucl/components/text", m = {
  emptyLabel: "Rich Text Editor",
  isEmpty: o,
  resourceType: r
}, w = t(m, i);
export {
  w as EditableText,
  r as TEXT_RESOURCE_TYPE
};
